<template>
  <div class="general">
    <filtro-cadu
      v-model="valueData"
      @limparFiltro="limparFiltro()"
      @filtrar="filtrar() "
      width="400"
    >
      <div slot="body" class="mx-5 filtro-email" >
        <v-row class="pb-0">
          <v-col cols="auto">
            <div class="fontColor1--text font-weight-bold">FILTRAR E-MAIL ÁREAS</div>
          </v-col>
        </v-row>
        <ValidationObserver ref="observer">
          <v-row class="pt-0">
            <v-col cols="20" class="pb-0 pt-3">
              <checkList-cadu
                ref="unimedCheck"
                :listaFiltro="listaUnimed"
                :tasks="unimedSelecionadas"
                titulo="Unimed"
                itemTextFiltro="textoExibicao"
                @filtradas="valores => unimedSelecionadas = valores"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <validation-provider name="area" mode="eager" rules="numeric">
                <checkList-cadu
                  ref="areaCheck"
                  :listaFiltro="listaAreas"
                  :tasks="areasSelecionadas"
                  titulo="Área"
                  itemTextFiltro="nome"
                  @filtradas="valores => areasSelecionadas = valores"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </ValidationObserver>

        <v-row no-gutters class="mt-2 mb-10">
          <v-col cols="12">
            <checkList-cadu
              ref="autocompleteCheck"
              :listaFiltro="listaStatus"
              :tasks="statusSelecionados"
              titulo="Status"
              itemTextFiltro="nome"
              @filtradas="valores => statusSelecionados = valores"
            />
          </v-col>
        </v-row>
      </div>
    </filtro-cadu>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ListarUnimed from '../../../../services/Unimed/ListarUnimed'
import EmailAreas from '../../../../services/EmailArea/EmailArea'
import Area from '../../../../services/Area'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },

  props: {
    value: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      valueData: this.value,
      tokenBearer: '',
      isLoading: false,
      parametros: '',

      // Models Autocomplete
      unimedSelecionadas: [],
      areasSelecionadas: [],
      statusSelecionados: [],

      // Lista dos autompletes
      listaUnimed: [],
      listaAreas: [],
      listaStatus: [],
      checkAll: [],

      checkBoxValueArea: [],

      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },

  async beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    await this.loadLoading()
  },

  methods: {
    async loadLoading () {
      this.isLoading = true
      await this.getAllUnimeds()
      await this.getAreas()
      await this.getStatus()
      this.isLoading = false
    },

    async getAllUnimeds () {
      let listarUnimed = new ListarUnimed(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await listarUnimed.getAll()
        this.listaUnimed = response.data
      } catch (err) {
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async getAreas () {
      let area = new Area(this.tokenBearer, this.$appConfig.config.API)

      try {
        let response = await area.getAreas()
        this.listaAreas = response.data
      } catch (err) {
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async getStatus () {
      let emailAreas = new EmailAreas(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await emailAreas.getStatus()
        this.listaStatus = response.data
      } catch (err) {
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },
    async limparFiltro () {
      this.unimedSelecionadas = []
      this.statusSelecionados = []
      this.areasSelecionadas = []
      this.parametros = ''
      await this.$nextTick()
      this.$refs.autocompleteCheck.clean()
      this.$refs.unimedCheck.clearAll()
      this.$refs.areaCheck.clearAll()
    },
    filtrar () {
      this.parametros = new URLSearchParams()

      this.areasSelecionadas.forEach(item => {
        this.parametros.append('tipoAreasId', item.id)
      })

      this.statusSelecionados.forEach(item => {
        let it = item.title.toUpperCase()

        if (it === 'NÃO CONFIRMADO') {
          it = 'NAO_CONFIRMADO'
        }

        this.parametros.append('status', it)
      })

      this.unimedSelecionadas.forEach(item => {
        this.parametros.append('unimedsId', item.id)
      })

      this.$emit('filtrar', this.parametros.toString())
    }
  },

  watch: {
    valueData () {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    },
    value () {
      this.valueData = this.value
    }
  }
}
</script>

<style scoped lang="sass">
.general
    color: rgba(0, 0, 0, 0.54)
    font-size: 0.875rem
    line-height: 1.375rem
    letter-spacing: 0.0071428571em
    z-index: 999999999999999
    position: fixed
.filtro-email
    width: 95%
    height: 100%
    overflow-x: hidden
    overflow-y: scroll
</style>
